// extracted by mini-css-extract-plugin
module.exports = {"container":"events-feed_container__FEKl9","pagination":"events-feed_pagination__F9HDZ"};